import { Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { useGetJobDetails } from "../api/queries/useGetJobDetails";

const tabStyle = {
  fontFamily: "Montserrat",
  color: "var(--Gray-500, #667085)",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  padding: "0px 4px 12px 4px",
  textTransform: "none",
  minHeight: "fit-content",
  minWidth: "fit-content",
};

const TABS = ["overview", "candidates", "hiringJourney", "jobBoost"] as const;
export type TabType = (typeof TABS)[number];

const JobDetailsTabsNavigation = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "components.jobOverviewTabsNavigation" });
  const { jobId } = useParams<{ jobId: string }>();

  const { data: jobDetails, isLoading: jobDetailsLoading } = useGetJobDetails(jobId);
  const CANDIDATES_COUNT = jobDetails?.data.jobSummary?.allCandidates ?? 0;

  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get("tab") || "overview";

  const handleTabChange = (event: React.SyntheticEvent, newValue: TabType) => {
    const searchParams = new URLSearchParams(location.search);
    Array.from(searchParams.keys()).forEach((key) => {
      searchParams.delete(key);
    });
    searchParams.set("tab", newValue);

    navigate({ search: searchParams.toString() });
  };

  return (
    <Tabs
      value={currentTab}
      onChange={handleTabChange}
      aria-label="job overview tabs"
      sx={{
        minHeight: "fit-content",
        borderBottom: "1px solid var(--Gray-200, #E4E7EC)",
        "& .MuiTabs-flexContainer": {
          gap: "24px",
        },
      }}
      variant="scrollable"
      scrollButtons="auto"
    >
      {TABS.map((tab) => (
        <Tab
          key={tab}
          label={tab === "candidates" ? t(tab, { count: CANDIDATES_COUNT }) : t(tab)}
          value={tab}
          sx={tabStyle}
          disabled={tab === "jobBoost" || tab === "hiringJourney"}
        />
      ))}
    </Tabs>
  );
};

export default JobDetailsTabsNavigation;
